import {CONSTANTS} from './Toast'
import Toast from './ToastFactory'
/**
 * need a toast that acts like this
 * RecurringToast({time: , message:, type})
 * toast.start()
 * toast.stop()
 */

class RecurringToast {
  constructor (setupOptions) {
    this.setupOptions = setupOptions
    this.run = false
    this.interval = null
  }

  start () {
    if (this.interval) {
      this.stop()
    }
    this.interval = setInterval(this.speak.bind(this), this.setupOptions.interval)
  }

  stop () {
    if (this.interval) {
      clearInterval(this.interval)
    }
    this.interval = null
  }

  speak () {
    const options = {...this.setupOptions, timeout: this.setupOptions.interval - 1000}
    switch (this.setupOptions.type) {
      case CONSTANTS.TYPE.SUCCESS:
        Toast.success(options)
        break
      case CONSTANTS.TYPE.WARNING:
        Toast.warning(options)
        break
      case CONSTANTS.TYPE.INFO:
        Toast.info(options)
        break
      case CONSTANTS.TYPE.ERROR:
        Toast.error(options)
        break
      default:
        Toast.info(options)
    }
  }
}

export default RecurringToast



// WEBPACK FOOTER //
// ./src/app/components/common/toasts/RecurringToast.js